import { Palette } from "./__internal__/palette";

export const Core = {
  surface: {
    primary: Palette.gray[100],
    secondary: Palette.gray[200],
    tertiary: Palette.gray[300],
  },
  border: {
    subdued: Palette.gray[700],
    muted: Palette.gray[400],
  },
  text: {
    primary: Palette.gray[900],
    subdued: Palette.gray[700],
    primaryInverse: Palette.gray[100],
  },
  icon: {
    primary: Palette.gray[900],
    subdued: Palette.gray[700],
    primaryInverse: Palette.gray[100],
  },
} as const;

export const Action = {
  surface: {
    default: Palette.gray[900],
    defaultInverse: Palette.gray[100],
    defaultContrast: Palette.gray[400],
    hover: Palette.gray[1000],
    active: Palette.gray[1000],
    disabled: Palette.gray[300],
    favorited: Palette.red[700],
  },
  border: {
    default: Palette.gray[900],
    defaultInverse: Palette.gray[100],
    defaultContrast: Palette.gray[400],
    hover: Palette.gray[1000],
    active: Palette.gray[1000],
    disabled: Palette.gray[400],
    focusRing: Palette.blue[700],
  },
  text: {
    default: Palette.gray[900],
    defaultInverse: Palette.gray[100],
    hover: Palette.gray[1000],
    active: Palette.gray[1000],
    disabled: Palette.gray[700],
  },
  icon: {
    default: Palette.gray[900],
    defaultInverse: Palette.gray[100],
    defaultContrast: Palette.gray[400],
    hover: Palette.gray[1000],
    active: Palette.gray[1000],
    disabled: Palette.gray[700],
  },
} as const;

export const Message = {
  text: {
    critical: Palette.red[700],
  },
  icon: {
    success: Palette.green[700],
    warning: Palette.yellow[800],
    critical: Palette.red[700],
    info: Palette.blue[1000],
  },
  border: {
    success: Palette.green[600],
    warning: Palette.yellow[400],
    critical: Palette.red[500],
    info: Palette.blue[400],
  },
  surface: {
    success: Palette.green[100],
    warning: Palette.yellow[100],
    critical: Palette.red[100],
    info: Palette.blue[200],
  },
} as const;

export const Program = {
  surface: {
    faireDirect: {
      primary: Palette.blue[200],
      primaryInverse: Palette.xp.blue[500],
    },
    insider: {
      primary: Palette.blue[100],
      primaryInverse: Palette.teal[900],
    },
    topShop: {
      primary: Palette.xp.green[200],
      primaryInverse: Palette.green[1000],
      secondary: Palette.green[500],
    },
  },
  text: {
    faireDirect: Palette.xp.blue[500],
    insider: Palette.teal[900],
    topShop: Palette.green[1000],
  },
  icon: {
    insider: Palette.teal[600],
    topShop: Palette.green[500],
    volumeBasedDiscounts: Palette.xp.red[800],
  },
} as const;

export const Expressive = {
  surface: {
    neutral: {
      primary: Palette.neutral[100],
      primaryInverse: Palette.neutral[1000],
    },
    yellow: {
      primary: Palette.yellow[200],
      primaryInverse: Palette.yellow[1000],
    },
    green: {
      primary: Palette.green[300],
      primaryInverse: Palette.green[1000],
    },
    blue: {
      primary: Palette.blue[200],
      primaryInverse: Palette.blue[1000],
    },
    red: {
      primary: Palette.red[200],
      primaryInverse: Palette.red[1000],
    },
    orange: {
      primary: Palette.orange[100],
      primaryInverse: Palette.orange[400],
    },
  },
  icon: {
    neutral: Palette.neutral[600],
    yellow: Palette.yellow[600],
    green: Palette.green[500],
    blue: Palette.blue[400],
    red: Palette.red[400],
    orange: Palette.orange[1000],
  },
  text: {
    neutral: {
      primary: Palette.neutral[1000],
      primaryInverse: Palette.neutral[100],
    },
    yellow: {
      primary: Palette.yellow[1000],
      primaryInverse: Palette.yellow[200],
    },
    green: {
      primary: Palette.green[1000],
      primaryInverse: Palette.green[300],
    },
    blue: {
      primary: Palette.blue[1000],
      primaryInverse: Palette.blue[200],
    },
    red: {
      primary: Palette.red[1000],
      primaryInverse: Palette.red[200],
    },
    orange: {
      primary: Palette.orange[400],
      primaryInverse: Palette.orange[100],
    },
  },
} as const;

export default {
  Action,
  Core,
  Expressive,
  Message,
  Program,
} as const;
